module.exports = __webpack_public_path__ + "img/index-intro-img.5d4bc42.png";